(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["womens-edit"] && !Shopify.designMode) return;
  try {
    
function initializeWomensEdit(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const filters=root.querySelectorAll('[data-filter]');
  const cards=root.querySelectorAll('[data-category]');
  function filter(value){filters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===value)));cards.forEach(card=>card.hidden=value!=='all'&&card.dataset.category!==value);}
  filters.forEach(button=>button.addEventListener('click',()=>filter(button.dataset.filter)));
  root.querySelectorAll('[data-category-link]').forEach(link=>link.addEventListener('click',()=>filter(link.dataset.categoryLink)));
}
document.querySelectorAll('[data-womens-edit]').forEach(initializeWomensEdit);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-womens-edit]').forEach(initializeWomensEdit));

  } catch(e) { console.error(e); }
})();
})();
